import { FC, useState } from "react"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import SaveIcon from "@mui/icons-material/Save"
import DeleteIcon from "@mui/icons-material/Delete"
import AddOutlinedIcon from "@mui/icons-material/AddOutlined"

export interface TabItem {
  addOption: boolean
  data: string
  id: number
  isEnable: boolean
  modify: boolean
  name: string
}

interface AttachmentSettingTabsProps {
  tabs: TabItem[]
  activeTabId: number
  onActiveTabChange: (tabId: number) => void
  onTabChange: (tab: TabItem) => void
  onSaveClick?: (tab: TabItem) => void
  onDeleteClick?: (tab: TabItem) => void
  onAddClick?: () => void
  isDataModified?: (tabId: number) => boolean
}

export const AttachmentSettingTabs: FC<AttachmentSettingTabsProps> = ({
  tabs,
  activeTabId,
  onActiveTabChange,
  onTabChange,
  onSaveClick,
  onDeleteClick,
  onAddClick,
  isDataModified,
}) => {
  const sortedTabs = [...tabs].sort((a, b) => a.id - b.id)
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const [tabToDelete, setTabToDelete] = useState<TabItem | null>(null)

  const handleTabClick = (tab: TabItem) => {
    onTabChange(tab)
  }

  const handleSaveClick = (tab: TabItem, e: React.MouseEvent) => {
    e.stopPropagation()
    if (onSaveClick && isDataModified?.(tab.id)) {
      onSaveClick(tab)
    }
  }

  const handleDeleteClick = (tab: TabItem, e: React.MouseEvent) => {
    e.stopPropagation()
    setTabToDelete(tab)
    setDeleteDialogOpen(true)
  }

  const handleConfirmDelete = () => {
    if (tabToDelete && onDeleteClick) {
      onDeleteClick(tabToDelete)
    }
    setDeleteDialogOpen(false)
    setTabToDelete(null)
  }

  const handleCancelDelete = () => {
    setDeleteDialogOpen(false)
    setTabToDelete(null)
  }

  const handleAddClick = () => {
    if (onAddClick) {
      onAddClick()
    }
  }

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "50px",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
        }}
      >
        {sortedTabs.map((tab) => (
          <Button
            key={tab.id}
            variant={activeTabId === tab.id ? "contained" : "outlined"}
            onClick={() => handleTabClick(tab)}
            sx={{
              width: activeTabId === tab.id && tab.modify ? "auto" : "fit-content",
              // px: activeTabId === tab.id && tab.modify ? 3 : 2,
              // pr: activeTabId === tab.id && tab.modify ? 3 : 2,
              py: 0,
              height: "40px",
              fontSize: "14px",
              textTransform: "none",
              position: "relative",
            }}
          >
            {tab.name}
            {activeTabId === tab.id && tab.modify && (
              <>
                <SaveIcon
                  titleAccess="save"
                  onClick={(e) => handleSaveClick(tab, e)}
                  sx={{
                    marginLeft: 3,
                    fontSize: "25px",
                    color: isDataModified?.(tab.id) ? '#fff' : 'action.disabled',

                  }}
                />
                <DeleteIcon
                  titleAccess="delete"
                  onClick={(e) => handleDeleteClick(tab, e)}
                  sx={{
                    marginLeft: 2,
                    fontSize: "25px",
                    cursor: 'pointer',
                    color: '#fff',
                  }}
                />
              </>
            )}
          </Button>
        ))}
        {tabs.length < 8 && (
          <Button
            variant="outlined"
            onClick={handleAddClick}
            sx={{
              minWidth: "fit-content",
              px: 1,
              py: 0,
              height: "40px",
            }}
          >
            <AddOutlinedIcon />
          </Button>
        )}
      </Box>
      <Dialog
        open={deleteDialogOpen}
      // onClose={handleCancelDelete}
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 3 }}>
          This will delete the protocol, proceed?
        </DialogContent>
        <DialogActions>
          <Button variant="outlined"
            sx={{ mr: 1 }} onClick={handleCancelDelete}>Cancel</Button>
          <Button onClick={handleConfirmDelete} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
